import { useState } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";

import Grid from "@mui/material/Grid";

import ImageCard from "../../components/ImageCard";
import { getTranslation } from "../../utils/translate";
import ListPage from "../../layouts/ListPage";
import useCountInJunction from "../../common/hooks/useCountInJunction";
import LibraryActions from "../../components/shared/LibraryActions";
import LazyLoad from "react-lazyload";
import { getBeefProductOverride } from "../../utils/overrides";
import { languages } from "../../utils/translate";
import useSWR from "swr";
import { pageNumber, pageSize } from "../../utils/pagination";

const RecipeList = () => {
  const retailer = useSelector((state) => state.retailer);

  const [language, setLanguage] = useState(languages[0]);
  const [page, setPage] = useState(pageNumber);

  const { data: pageData, isLoading: pageDataLoading } = useSWR({
    url: `recipe?meta=*`,
    fields: `*,layout_translations.*,imagegallery.*,retailers.retailer_id`,
    sort: "date_created",
    limit: pageSize,
    page,
  });

  const dataCount = useCountInJunction(
    "recipe_retailer",
    {
      aggregate: {
        count: "*",
      },
      filter: {
        _and: [{ retailer_id: { _eq: retailer.id } }],
      },
    },
    pageDataLoading
  );

  const summaryValues = [
    {
      label: "Total",
      value: pageData?.meta?.filter_count?.toLocaleString() || "-",
    },
    {
      label: "Collected",
      value: dataCount || "-",
    },
  ];

  const handleSearchComplete = (results) => {};

  return (
    <ListPage
      title={"Recipes"}
      description={"View and manage recipes."}
      summaries={summaryValues}
      searchOnly={["RECIPES"]}
      language={language}
      setLanguage={setLanguage}
      defaultPayload={{
        url: `recipe?meta=*`,
        fields: ["*", "translations.*"],
        filter: {
          _and: [
            {
              _or: [
                {
                  retailers: {
                    retailer_id: {
                      _eq: retailer.id,
                    },
                  },
                },
              ],
            },
          ],
        },
        sort: "-date_created",
        limit: -1,
      }}
      defaultResponseHandler={(items) => {
        return (
          items?.data?.map((item) => {
            const beefOverride = getBeefProductOverride(item, retailer, {
              code: language.code,
            });
            const translatedBeefOverride = getTranslation(beefOverride, {
              key: "languages_code",
              code: language.code,
            });

            const translatedBeefCut = getTranslation(
              item,
              { key: "languages_id", code: language.code },
              "translations"
            );
            const imageUrl = `${process.env.REACT_APP_API_URL}/assets/${item?.image}`;

            return {
              id: item?.id,
              title: translatedBeefOverride?.name || translatedBeefCut.name,
              description: translatedBeefCut.description,
              url: `/beef-cuts/${item?.id}`,
              data: item,
              imageUrl: imageUrl,
            };
          }) || []
        );
      }}
      handleSearchComplete={handleSearchComplete}
      searchStorageKey={"beef-cuts"}
      breadcrumbsLinks={[
        {
          url: "/recipes-menu",
          content: "Content Library",
        },
      ]}
      pageNumber={page}
      setPageNumber={setPage}
      numberOfPages={Math.ceil(pageData?.meta?.total_count / pageSize)}
      loading={pageDataLoading}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {pageData?.data?.map((item) => (
            <Grid key={item.id} item xs={6} sm={4} md={4} lg={3} xl={2}>
              <Box
                sx={{
                  height: "100%",
                }}
              >
                <LazyLoad height="100%">
                  <ImageCard
                    url={`/recipes/${item.id}`}
                    item={{
                      title: getTranslation(
                        item,
                        { key: "languages_code", code: language.code },
                        "layout_translations"
                      ).name,
                      description: getTranslation(
                        item,
                        { key: "languages_code", code: language.code },
                        "layout_translations"
                      ).summary,
                      url:
                        `${process.env.REACT_APP_API_URL}/assets/${item?.imagegallery[0]?.directus_files_id}` ||
                        "",
                    }}
                    footerAction={
                      <LibraryActions
                        id={item.id}
                        junctionTable="recipe_retailer"
                        junctionPayload={{
                          recipe_id: item.id,
                          retailer_id: retailer.id,
                        }}
                      />
                    }
                    imageBackground="#fff"
                    imageFit="cover"
                  />
                </LazyLoad>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  );
};

export default RecipeList;
